import { DateFormat, RoomingListParams } from "../objects/roomingListParams";
import { RoomingListParamsListCriteria } from "../objects/roomingListParamsList";

export const EMPTY_EXPORT_SETTING: RoomingListParams = {
    name: "",
    localization: [],
    template_type: 'CIRCUIT',
    date_format: "DAY_FIRST",
    amount_float: "POINT",
    variable_matching: {},
    display_columns_name: true,
    variable_column: []
};

export const EMPTY_ROOMING_LIST_PARAMS_CRITERIA: RoomingListParamsListCriteria = {
    limit: 50,
    page: 0,
    search: ''
};

export const DATE_FORMAT_LABEL: Record<DateFormat,string> = {
    DAY_FIRST: "JJ/MM/AAAA",
    MONTH_FIRST: "MM/JJ/AAAA",
    YEAR_FIRST: "AAAA/MM/JJ"
};